import { axiosWithConfig } from '@assembly/config/axios'

export const getCandidates = (payload: any) => {
    return axiosWithConfig.post(`/recruiting/admin/candidates/search`, payload, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

export const updateCandidate = (payload: any) => {
    return axiosWithConfig.post('/recruiting/admin/candidate', payload)
}

export const updateCandidatesState = async (candidates: string[], state: string) => {
    return await axiosWithConfig.post(`/recruiting/admin/candidates/state/${state}`, { candidates: candidates.join(',') }, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

export const updateCandidatesReScoring = async (candidates: string[], rescore: boolean) => {
    return await axiosWithConfig.post(`/recruiting/admin/candidates/rescoring/${rescore}`, { candidates: candidates.join(',') }, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

export const uploadMedia = (payload: any, onProgressChange?: any) => {
    return axiosWithConfig.put(`/media/admin/candidate/setup`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent: any) => {
            let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            if (onProgressChange) onProgressChange(percentCompleted)
        },
    })
}

export const sendEmail = (payload: any) => {
    return axiosWithConfig.post(`/recruiting/admin/candidates/email_update`, payload, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}